import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import ParameterFieldBase from '../../../../_common/platform/ts/ParameterFieldBase';
import EditComponent, { IChartAxisArrayFieldOptions } from './ChartAxisArrayField_inThemes';

export class ChartAxisArrayField_inThemes extends ParameterFieldBase<IChartAxisArrayFieldOptions> {
    public static EditComponent = EditComponent;
    public static getDefaultValue() {
        return {};
    }

    constructor(glob: IGlob, title: string, validators?: any, defaultVal?: any, options?: IChartAxisArrayFieldOptions) {
        if (defaultVal == null) {
            defaultVal = ChartAxisArrayField_inThemes.getDefaultValue();
        }

        super(glob, title, [], validators, defaultVal, options);
    }
}
